import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { useTheme, jsx } from '@emotion/react';
import Loader from '../../shared-components/loader/index.js';
import ButtonContainer from '../../shared-components/container/index.js';
import withDeprecationWarning from '../../../../utils/withDeprecationWarning/index.js';
import { deprecatedProperties } from '../../deprecatedPropsHandler.js';
import { isDefined } from '../../../../utils/isDefined/index.js';
import { ButtonBase, ButtonContents, ButtonText } from '../../style.js';

var _excluded = ["buttonColor", "buttonType", "children", "disabled", "icon", "isFullWidth", "isLoading", "loading", "onClick", "textColor"];

var Button = _ref => {
  var {
    buttonColor,
    buttonType = 'primary',
    children,
    disabled = false,
    icon = null,
    isFullWidth = false,
    isLoading = false,
    loading = undefined,
    onClick,
    textColor
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var buttonColorWithTheme = buttonColor !== null && buttonColor !== void 0 ? buttonColor : theme.COLORS.primary;
  var loadingVal = loading === undefined ? isLoading : loading;
  var hasIcon = isDefined(icon) && icon !== false;
  return jsx(ButtonBase, _extends({
    buttonColor: buttonColorWithTheme,
    buttonType: buttonType,
    disabled: disabled,
    isFullWidth: isFullWidth,
    isLoading: loadingVal,
    onClick: !disabled && !loadingVal ? onClick : event => {
      event.preventDefault();
    },
    textColor: textColor,
    type: "button" // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), jsx(ButtonContents, {
    hasIcon: hasIcon,
    isFullWidth: isFullWidth,
    isLoading: loadingVal
  }, icon, jsx(ButtonText, {
    hasIcon: hasIcon,
    isLoading: loadingVal
  }, children)), jsx(Loader, {
    buttonColor: buttonColorWithTheme,
    buttonType: buttonType,
    disabled: disabled,
    isFullWidth: isFullWidth,
    isLoading: loadingVal,
    textColor: textColor
  }));
};

Button.Container = ButtonContainer;
var ButtonComponent = withDeprecationWarning(Button, deprecatedProperties);

export { ButtonComponent as Button };
